import { Badge, Button } from '@themesberg/react-bootstrap';
import React from 'react';
import { returnUserReadableDateTime } from '../../../utils/datetime';
import { getTripBadgeStatus } from '../../../utils/trips';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const currentLoadersColumns = (onMarkOut) => {
  return [
    {
      text: 'Loader Code',
      dataField: 'loaderCode',
      formatter: (cell, row) => {
        return <div>{row?.loader?.loaderCode}</div>;
      },
    },
    {
      text: 'Loader Name',
      dataField: 'name',
      formatter: (cell, row) => {
        return <div>{row?.loader?.name}</div>;
      },
    },
    {
      text: 'Contact',
      dataField: 'mobileNo',
      formatter: (cell, row) => {
        return <div>{row?.loader?.mobileNo}</div>;
      },
    },
    {
      text: 'Agency',
      dataField: 'agency',
      formatter: (cell, row) => {
        return <div>{row?.loader?.agency}</div>;
      },
    },
    {
      text: 'Status',
      dataField: 'status',
      formatter: (cell, row) => {
        return (
          <Badge bg={getTripBadgeStatus(row?.status)} className="badge-lg">
            {row?.status}
          </Badge>
        );
      },
    },
    {
      text: 'Entry Time',
      dataField: 'entryTime',
      formatter: (cell, row) => {
        return (
          <div>
            {returnUserReadableDateTime(row?.entryTime?.iso || row?.entryTime)}
          </div>
        );
      },
    },
    {
      text: 'Action',
      dataField: 'action',
      formatter: (cell, row) => {
        return (
          <div>
            <Button onClick={() => onMarkOut(row)}>Mark Out</Button>
          </div>
        );
      },
    },
  ];
};

export const loaderActivityColumns = (onViewClick) => {
  return [
    {
      text: 'Loader Code',
      dataField: 'loaderCode',
      formatter: (cell, row) => {
        return <div>{row?.loader?.loaderCode}</div>;
      },
    },
    {
      text: 'Loader Name',
      dataField: 'name',
      formatter: (cell, row) => {
        return <div>{row?.loader?.name}</div>;
      },
    },
    {
      text: 'Contact',
      dataField: 'mobileNo',
      formatter: (cell, row) => {
        return <div>{row?.loader?.mobileNo}</div>;
      },
    },
    {
      text: 'Entry Time',
      dataField: 'entryTime',
      formatter: (cell, row) => {
        return <div>{returnUserReadableDateTime(row?.entryTime)}</div>;
      },
    },
    {
      text: 'Exit Time',
      dataField: 'exitTime',
      formatter: (cell, row) => {
        return <div>{returnUserReadableDateTime(row?.exitTime) || '-'}</div>;
      },
    },
    {
      text: 'Warehouse',
      dataField: 'warehouse',
    },
    {
      text: 'View',
      dataField: 'action',
      formatter: (cell, row) => {
        return (
          <div>
            <Button
              onClick={() => onViewClick(row)}
              variant="outline"
              className="p-0"
            >
              <FontAwesomeIcon icon={faEye} />
            </Button>
          </div>
        );
      },
    },
  ];
};
